import "./style.css";
import { r, m, o, t } from "./variables-x6F5JYca-DO6LtXTE-BfP5x-cK.js";
var I = ((r$1) => (r$1[r$1.DEFAULT = parseInt(r, 10)] = "DEFAULT", r$1[r$1.MEDIUM = parseInt(m, 10)] = "MEDIUM", r$1[r$1.LARGE = parseInt(o, 10)] = "LARGE", r$1[r$1.XLARGE = parseInt(t, 10)] = "XLARGE", r$1))(I || {});
export {
  I
};
